"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.minimumLength = void 0;
const lang_1 = __importDefault(require("../../../lang"));
exports.minimumLength = 8;
function password() {
    return this
        .matches(/\w*[a-z]\w*/, (0, lang_1.default)().validation.passwordLowerCaseLetterRequired())
        .matches(/\d/, (0, lang_1.default)().validation.passwordNumerRequired())
        .matches(/[!+@#$%^&*()\-_"=+{}; :,<.>]/, (0, lang_1.default)().validation.passwordSpecialCharacterRequired())
        .min(exports.minimumLength, ({ min }) => (0, lang_1.default)().validation.passwordMinimumLength(min));
}
exports.default = password;
